module.exports = __webpack_public_path__ + "static/media/Lato-regular.ff97d89c.svg";